import { render, staticRenderFns } from "./singleProduct.vue?vue&type=template&id=0c6f3a00&"
import script from "./singleProduct.vue?vue&type=script&lang=js&"
export * from "./singleProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports